import React, { useState } from 'react';
import { CommunitySidebar } from './CommunitySidebar';
import { ZijMenuMobielKnop, PaginaKop } from './ZijMenu';
import { usePaginaBanner } from './paginaBanner';

interface CommunityLayoutProps {
  children: React.ReactNode;
}

export const CommunityLayout: React.FC<CommunityLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Paginatitel uit de route (Layout); staat naast het ZijMenu i.p.v. als banner erboven
  const banner = usePaginaBanner();

  return (
    <div className="min-h-screen bg-gray-50">
      <ZijMenuMobielKnop onClick={() => setSidebarOpen(true)} />
      <div className="max-w-7xl mx-auto flex min-h-[calc(100vh-4rem)]">
        <CommunitySidebar mobileOpen={sidebarOpen} onMobileClose={() => setSidebarOpen(false)} />
        <div className="flex-1 min-w-0 overflow-y-auto">
          {banner && <PaginaKop titel={banner.title} ondertitel={banner.subtitle} className="px-4 sm:px-6 pt-6" />}
          {children}
        </div>
      </div>
    </div>
  );
};
